import { defineComponent as _defineComponent } from 'vue'
import { Inspiration } from '@/types/discover'
import { thumbnailImage } from '@/utils/utility-manager'


export default /*#__PURE__*/_defineComponent({
  __name: 'InspirationSearchCard',
  props: {
    inspiration: null
  },
  setup(__props: any) {



return { __sfc: true,thumbnailImage }
}

})